import script from "./ProjectListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectListItem.vue?vue&type=style&index=0&id=6c402a9d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c402a9d"]])

export default __exports__